import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Play, X, Maximize2 } from 'lucide-react';
export function ClosingScreen() {
  const [showVideo, setShowVideo] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  return <section className="min-h-screen flex flex-col items-center justify-center bg-white px-6 py-20" data-id="element-67">
      <div className="max-w-4xl w-full mx-auto flex flex-col items-center" data-id="element-68">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-bold text-slate-900 text-center mb-6" data-id="element-69">
          See it in action
        </motion.h2>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-lg text-slate-400 text-center mb-12 max-w-xl" data-id="element-70">
          Start with clarity. Earn attention. Then ask for action.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3,
        duration: 0.6
      }} className="w-full relative" data-id="element-71">
          <div className="absolute -inset-3 bg-gradient-to-br from-purple-100 to-emerald-100 rounded-3xl blur-xl opacity-60" data-id="element-72" />

          <div className="relative rounded-2xl overflow-hidden shadow-xl" data-id="element-73">
            {/* Background image always visible */}
            <img src="https://cdn.magicpatterns.com/uploads/gnQ8SM99ADxWzzLrpZ1gAH/Screenshot_2026-04-09_at_11.14.29.png" alt="Chronic Hand Eczema experience" className="w-full h-auto block" data-id="element-74" />

            <AnimatePresence data-id="element-75">
              {showVideo && !isFullscreen && <motion.div key="video-overlay" initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} exit={{
              opacity: 0,
              scale: 0.9
            }} transition={{
              duration: 0.3
            }} className="absolute inset-0 flex items-center justify-center p-6 md:p-12 bg-black/40 backdrop-blur-sm" data-id="element-76">
                  <div className="relative w-full max-w-2xl rounded-xl overflow-hidden shadow-2xl" style={{
                aspectRatio: '16/9'
              }} data-id="element-77">
                    <div className="absolute top-3 right-3 z-20 flex items-center gap-2" data-id="element-78">
                      <button onClick={() => setIsFullscreen(true)} className="w-9 h-9 rounded-full bg-black/60 hover:bg-black/80 flex items-center justify-center text-white transition-colors" data-id="element-79">
                        <Maximize2 size={16} data-id="element-80" />
                      </button>
                      <button onClick={() => {
                    setShowVideo(false);
                    setIsFullscreen(false);
                  }} className="w-9 h-9 rounded-full bg-black/60 hover:bg-black/80 flex items-center justify-center text-white transition-colors" data-id="element-81">
                        <X size={18} data-id="element-82" />
                      </button>
                    </div>
                    <iframe src="https://player.snakker.io/s/cHonpmm3C0" className="w-full h-full absolute inset-0" allow="autoplay; fullscreen" style={{
                  border: 'none'
                }} data-id="element-83" />
                  </div>
                </motion.div>}
            </AnimatePresence>

            {/* Fullscreen mode */}
            <AnimatePresence data-id="element-84">
              {showVideo && isFullscreen && <motion.div key="video-fullscreen" initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} exit={{
              opacity: 0
            }} className="fixed inset-0 z-50 bg-black flex items-center justify-center" data-id="element-85">
                  <div className="absolute top-4 right-4 z-20 flex items-center gap-2" data-id="element-86">
                    <button onClick={() => setIsFullscreen(false)} className="w-10 h-10 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center text-white transition-colors" data-id="element-87">
                      <Maximize2 size={18} data-id="element-88" />
                    </button>
                    <button onClick={() => {
                  setShowVideo(false);
                  setIsFullscreen(false);
                }} className="w-10 h-10 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center text-white transition-colors" data-id="element-89">
                      <X size={20} data-id="element-90" />
                    </button>
                  </div>
                  <iframe src="https://player.snakker.io/s/cHonpmm3C0" className="w-full h-full" allow="autoplay; fullscreen" style={{
                border: 'none'
              }} data-id="element-91" />
                </motion.div>}
            </AnimatePresence>

            {/* Play button overlay — only when video not playing */}
            {!showVideo && <>
                <div className="absolute inset-0 bg-black/10 pointer-events-none" data-id="element-92" />

                <div className="absolute inset-0 cursor-pointer" onClick={() => setShowVideo(true)} data-id="element-93">
                  {/* Animated pulse rings */}
                  <motion.div animate={{
                scale: [1, 1.8],
                opacity: [0.3, 0]
              }} transition={{
                repeat: Infinity,
                duration: 2.5,
                ease: 'easeOut'
              }} className="absolute top-[35%] left-[42%] -translate-x-1/2 -translate-y-1/2 w-28 h-28 rounded-full border-2 border-white/60" data-id="element-94" />
                  <motion.div animate={{
                scale: [1, 2.2],
                opacity: [0.2, 0]
              }} transition={{
                repeat: Infinity,
                duration: 2.5,
                ease: 'easeOut',
                delay: 0.5
              }} className="absolute top-[35%] left-[42%] -translate-x-1/2 -translate-y-1/2 w-28 h-28 rounded-full border-2 border-purple-300/60" data-id="element-95" />
                  <motion.div animate={{
                scale: [1, 2.6],
                opacity: [0.15, 0]
              }} transition={{
                repeat: Infinity,
                duration: 2.5,
                ease: 'easeOut',
                delay: 1
              }} className="absolute top-[35%] left-[42%] -translate-x-1/2 -translate-y-1/2 w-28 h-28 rounded-full border border-white/30" data-id="element-96" />

                  {/* Play button */}
                  <motion.div animate={{
                scale: [1, 1.06, 1]
              }} transition={{
                repeat: Infinity,
                duration: 2.5,
                ease: 'easeInOut'
              }} className="absolute top-[35%] left-[42%] -translate-x-1/2 -translate-y-1/2 w-28 h-28 rounded-full bg-gradient-to-br from-purple-600 to-purple-500 shadow-xl shadow-purple-500/30 flex items-center justify-center z-10" data-id="element-97">
                    <Play size={48} className="text-white ml-2" fill="white" data-id="element-98" />
                  </motion.div>
                </div>
              </>}
          </div>
        </motion.div>
      </div>
    </section>;
}